var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostfolioMovement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6807 3.3005C24.609 3.71716 24.5732 4.13383 24.5732 4.5505C24.5732 8.3005 27.834 11.3322 31.8473 11.3322C32.2953 11.3322 32.7253 11.2838 33.1732 11.2172V24.6655C33.1732 30.3172 29.5898 33.6672 23.4982 33.6672H10.2596C4.1661 33.6672 0.582764 30.3172 0.582764 24.6655V12.3338C0.582764 6.66716 4.1661 3.3005 10.2596 3.3005H24.6807ZM25.0408 13.4338C24.5553 13.3838 24.0733 13.5838 23.7848 13.9505L19.4508 19.1672L14.4861 15.5338C14.1815 15.3172 13.8232 15.2322 13.4648 15.2672C13.1083 15.3172 12.7858 15.4988 12.569 15.7655L7.26747 22.1838L7.15818 22.3338C6.8536 22.8655 6.99693 23.5488 7.53443 23.9172C7.78526 24.0672 8.05401 24.1672 8.3586 24.1672C8.77247 24.1838 9.16485 23.9822 9.41568 23.6672L13.9128 18.2822L19.019 21.8505L19.1803 21.9488C19.7536 22.2322 20.4703 22.1005 20.8823 21.5988L26.0603 15.3838L25.9886 15.4172C26.2753 15.0505 26.329 14.5838 26.1319 14.1672C25.9366 13.7505 25.5048 13.4672 25.0408 13.4338ZM32.0984 0.333328C34.4813 0.333328 36.4163 2.13333 36.4163 4.35C36.4163 6.56666 34.4813 8.36666 32.0984 8.36666C29.7154 8.36666 27.7804 6.56666 27.7804 4.35C27.7804 2.13333 29.7154 0.333328 32.0984 0.333328Z",
    fill: "#1F4DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostfolioMovement);
export default __webpack_public_path__ + "static/media/postfolio_movement.54224615883ac9886ac15c111083938f.svg";
export { ForwardRef as ReactComponent };